import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function analysisFormList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/form/list${queryString}`,
  );
}

export async function analysisFormCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    analysis_id: string;
    form_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/form/create`,
    payload,
  );
}

export async function analysisFormDelete(account_id: string, item_id: string) {
  return await clientAxios.del(
    `account/${account_id}/analysis/form/${item_id}/delete`,
  );
}
